"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const StyledEllipsis = (props) => {
    const { children, maxWidth } = props;
    return (react_1.default.createElement("div", { style: { maxWidth, whiteSpace: 'nowrap' } },
        react_1.default.createElement(Box_1.default, { component: "div", textOverflow: "ellipsis", overflow: "hidden" }, children)));
};
StyledEllipsis.propTypes = {
    children: prop_types_1.default.node.isRequired,
    maxWidth: prop_types_1.default.number.isRequired,
};
exports.default = StyledEllipsis;
